import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";

import { obtenerCountries } from "../../../API/Global/Countries/CountriesRequests";
import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { Button } from "primereact/button";
// import CurrencyCrudModal from "./CurrencyCRUD/CurrencyCrud";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import CountriesCrudModal from "./CountriesCRUD/CountriesCrud";

// import './categoriaStyle.scss';

export const CountriesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [country, setCountry] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const c = await obtenerCountries();
    setCountry(c);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdCountry",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      width: 100,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Country",
      header: "País",
      headerEn: "Country",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    { field: "Iso", header: "ISO", headerEn: "ISO" },
    { field: "Iso3", header: "ISO 3", headerEn: "ISO 3", flex: 1 },
    { field: "NumCode", header: "Código Numérico", headerEn: "Numeric Code" },
    {
      field: "PhoneCode",
      header: "Código Telefónico",
      headerEn: "Telephone Code",
    },
    {
      field: "IdCountry",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: country,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "pais", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "pais", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CountriesCrudModal
          toastRef={toast}
          paisesDialog={showDialog}
          pais={selected}
          setPaisesDialog={setShowDialog}
          getPaises={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default CountriesScreen;
